import React from "react";
import { Progress } from "antd";
import { GraduationCap, BookOpen, Clock, Calendar, Award, Users, LucideCircleCheck } from "lucide-react";

export default function SelectCourseCard({
  title,
  subtitle,
  level,
  category,
  duration,
  startDate,
  instructor,
  enrolled,
  capacity,
  index,
  selected,
  onClick,
}) {
  const percent = Math.round((enrolled / capacity) * 100);
  const spotsLeft = capacity - enrolled;

  const progressColor = index % 2 === 0
    ? { from: "#10b981", to: "#06b6d4" }  
    : { from: "#facc15", to: "#f97316" }; 



  return (
    <div
      onClick={onClick}
      className={`rounded-2xl border-2 transition-all shadow-sm group cursor-pointer overflow-hidden  ${
        selected
          ? "border-purple-500 bg-gradient-to-br from-purple-50 to-indigo-50 dark:from-purple-800 dark:to-white/10 dark:border-purple-800"
          : "border-slate-200 hover:border-purple-300 bg-white hover:shadow-xl dark:bg-white/10  dark:hover:bg-white/20"
      }`}
    >
      <div className="p-5 ">
        <div className="flex items-start justify-between">
          <div className="flex items-center gap-2 mb-2">
            <div
              className={`p-2 rounded-xl transition-colors ${
                selected
                  ? "bg-purple-500"
                  : "bg-slate-200 group-hover:bg-purple-100"
              }`}
            >
              <GraduationCap
                size={16}
                className={`transition-colors ${
                  selected ? "text-white" : "text-slate-600 group-hover:text-purple-600"
                }`}
              />
            </div>
            <h4 className="font-semibold text-[16px] dark:text-white">{title}</h4>
          </div>
          <span
            className={`text-[11px] inline-block mt-2 status-indicator ${level
                .toLowerCase()
                .replace(/\s+/g, "-")}`}
            >
            {level}
          </span>
        </div>

        <p className="text-[13px] text-gray-500 mb-4 dark:text-slate-100">{subtitle}</p>

        <div className="grid grid-cols-2 gap-3 mb-4">
          <div className="flex items-center gap-2 p-2 rounded-lg bg-slate-50 dark:bg-white/30">
            <BookOpen size={16} className="text-purple-600 dark:text-purple-300" />
            <div>
              <p className="text-[10px] text-gray-500 dark:text-gray-100">Category</p>
              <p className="text-[12px] font-semibold dark:text-white">{category}</p>
            </div>
          </div>

          <div className="flex items-center gap-2 p-2 rounded-lg bg-slate-50 dark:bg-white/30">
            <Clock size={16} className="text-blue-600 dark:text-blue-300" />
            <div>
              <p className="text-[10px] text-gray-500 dark:text-gray-100">Duration</p>
              <p className="text-[12px] font-semibold dark:text-white">{duration}</p>
            </div>
          </div>

          <div className="flex items-center gap-2 p-2 rounded-lg bg-slate-50 dark:bg-white/30">
            <Calendar size={16} className="text-emerald-600 dark:text-emerald-300" />
            <div>
              <p className="text-[10px] text-gray-500 dark:text-gray-100">Starts</p>
              <p className="text-[12px] font-semibold dark:text-white">{startDate}</p>
            </div>
          </div>

          <div className="flex items-center gap-2 p-2 rounded-lg bg-slate-50 dark:bg-white/30">
            <Award size={16} className="text-amber-600 dark:text-amber-300" />
            <div>
              <p className="text-[10px] text-gray-500 dark:text-gray-100">Instructor</p>
              <p className="text-[12px] font-semibold truncate dark:text-white">{instructor}</p>
            </div>
          </div>
        </div>

        <div>
          <div className="flex items-center justify-between text-[12px]">
            <span className="text-gray-500 flex items-center gap-1 dark:text-slate-100">
              <Users size={12} /> Enrollment
            </span>
            <span className="font-semibold dark:text-white">
              {enrolled}/{capacity}
            </span>
          </div>
          <Progress percent={percent} showInfo={false} strokeColor={progressColor} />
          <p className="text-[11px] text-gray-500 dark:text-slate-100">{spotsLeft} spots remaining</p>
        </div>

        {selected && (
          <div className="w-full mt-4 flex items-center justify-center gap-2 bg-gradient-to-r from-purple-500 to-indigo-500 border-0 p-2 rounded-xl font-semibold text-white">
            <LucideCircleCheck size={16} />
            <span className="flex gap-2 text-[13px] ">
               Course Selected
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
